import React, { useEffect, useCallback, useRef, useMemo, useState, useLayoutEffect } from 'react';
// import AgGrid from "./AgGrid"
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { columnwithDefs } from "./columnDefs_vehicles";
import Constants from "./Masters_constants";
import redirectURL from "../redirectURL";
import EditItem from './EditItem'
import DeletePartner from './deleteItem'
import SweetAlert from 'react-bootstrap-sweetalert';
import { getHyphenDDMMMYYYYHHMM } from '../common/utils';
import { format } from 'date-fns';
import BulkUploadModal from './BulkUploadModal.js';
import Select from 'react-select';
import { State, City } from "country-state-city";
import EditLogsConsignments from './editlogsConsignments.js';
import CustomDialogForMasterEditLogs from './CustomDialogForMasterEditLogs.js';
import TransitDaysBufferMaster from './transitDaysBufferMaster.js';
import ZoneWiseBufferMaster from './zonewisebuffertable.js';
import SeasonalBufferMaster from './seasonalbuffermaster.js';
import DelayCategoryMaster from './delaycategorymaster.js';
import { SubmitBtn } from "../common/utils.js";
import moment from "moment";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker'





function Masters() {
    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
    var localStorageEmail = localStorage.getItem("email")

    var [rowData, setRowData] = useState([])
    var [columnDefs1, setColumnDefs1] = useState([

        {
            headerName: "",
            field: "submit_btn",
            colId: "submit_btn",
            width: 80,
            filter: false,
            resizable: true,
            cellRendererSelector: function (param) {
                try {
                    // Check if any edit was made (i.e., if isEdited is true)

                    return {
                        component: SubmitBtn,
                        params: {
                            onClickEditDeliveryDate: onClickSaveTAT,
                        }
                    };

                } catch (err) {
                    console.log(err);
                    return null;
                }
            },
        },
        {
            headerName: "",
            field: "edit_logs",
            colId: "edit_logs",
            width: 50,
            pinned: "left",
            filter: false,
            cellRendererSelector: function (param) {
                try {
                    if (!!param.data._id) {
                        // if(tabName.value === "active"){
                        return {
                            component: EditLogsConsignments,
                            params: {
                                onClickActive: onClickEditLogs,
                                iconType: "edit",
                                tooltip: "Edit Logs",
                                disabled: ([0, null, undefined].includes(param.data.is_updated))

                            }
                            // };                           
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
            headerClass: 'bold-header'
        },


    ])
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    var tatMasterColumns = [
        {
            headerName: "Consigner Pincode",
            field: "consigner_pincode",
            width: 240,
            filter: true,
            editable: true,
            resizable: true,
            valueGetter: function (params) {
                // Ensure a valid pincode is returned (only 6 digits allowed)
                const pincode = params.data.consigner_pincode;
                return pincode && /^[0-9]{6}$/.test(pincode) ? pincode : "";
            },
            valueSetter: function (params) {
                const newValue = params.newValue.trim();
                // Validate if the pincode is exactly 6 digits
                if (/^[0-9]{6}$/.test(newValue)) {
                    params.data.consigner_pincode = newValue; // Store valid pincode
                    return true; // Accept the change
                } else {
                    params.data.consigner_pincode = ""; // Clear invalid pincode
                    return false; // Reject the change
                }
            },
            cellStyle: function (params) {
                // Highlight the cell with a red background if consignee_pincode is invalid
                const pincode = params.value;
                if (!/^[0-9]{6}$/.test(pincode)) {
                    return {
                        backgroundColor: "#c85f62", // Light red background for invalid pincode
                    };
                }
                return null; // No special styling for valid pincode
            },
            headerClass: 'bold-header'
        },


        {
            headerName: "Consignee Pincode",
            field: "consignee_pincode",
            width: 240,
            filter: true,
            editable: true,
            resizable: true,
            valueGetter: function (params) {
                // Ensure a valid pincode is returned (only 6 digits allowed)
                const pincode = params.data.consignee_pincode;
                return pincode && /^[0-9]{6}$/.test(pincode) ? pincode : "";
            },
            valueSetter: function (params) {
                const newValue = params.newValue.trim();
                // Validate if the pincode is exactly 6 digits
                if (/^[0-9]{6}$/.test(newValue)) {
                    params.data.consignee_pincode = newValue; // Store valid pincode
                    return true; // Accept the change
                } else {
                    params.data.consignee_pincode = ""; // Clear invalid pincode
                    return false; // Reject the change
                }
            },
            cellStyle: function (params) {
                // Highlight the cell with a red background if consignee_pincode is invalid
                const pincode = params.value;
                if (!/^[0-9]{6}$/.test(pincode)) {
                    return {
                        backgroundColor: "#c85f62", // Light red background for invalid pincode
                    };
                }
                return null; // No special styling for valid pincode
            },
            headerClass: 'bold-header'
        }
        ,


        {
            headerName: "Transporter Name",
            field: "transporter_name",
            width: 240,
            filter: true,
            editable: true,

            // ✅ valueGetter: Returns only valid transporter types (formatted correctly)
            valueGetter: function (params) {
                let transporterValue = params.data.transporter_name ? params.data.transporter_name.trim() : "";
                const validTransporters = tptRecords;

                // Convert input to uppercase for case-insensitive comparison
                transporterValue = transporterValue.toLowerCase();

                return validTransporters.includes(transporterValue) ? transporterValue : "";
            },

            // ✅ valueSetter: Accepts lower/upper case but stores only uppercase
            valueSetter: function (params) {
                let newValue = params.newValue ? params.newValue.trim() : "";
                const validTransporters = tptRecords;

                // Convert input to uppercase for case-insensitive comparison
                newValue = newValue.toLowerCase();

                if (validTransporters.includes(newValue)) {
                    params.data.transporter_name = newValue; // Store only uppercase values
                    return true; // Accept the change
                } else {
                    params.data.transporter_name = ""; // Clear the value if invalid
                    return false; // Reject the change
                }
            },

            // ✅ cellStyle: Highlights invalid values with red background
            cellStyle: function (params) {
                const transporterValue = params.value ? params.value.trim().toLowerCase() : "";
                const validTransporters = tptRecords;

                if (!validTransporters.includes(transporterValue) && transporterValue !== "") {
                    return {
                        backgroundColor: "#c85f62", // Light red background for invalid values
                        // color: "#fff" // White text for better contrast
                    };
                }
                return null; // Default style for valid values
            },

            headerClass: 'bold-header'
        },
        {
            headerName: "Transit Time",
            field: "transit_time",
            width: 240,
            filter: true,
            editable: true,
            resizable: true,
            valueGetter: function (params) {
                const transitTime = params.data.transit_time;
                // Return value if it's a valid integer
                return Number.isInteger(Number(transitTime)) ? transitTime : "";
            },
            valueSetter: function (params) {
                const newValue = params.newValue.trim();
                // Check if the new value is a valid integer
                if (Number.isInteger(Number(newValue)) && newValue !== "") {
                    params.data.transit_time = parseInt(newValue, 10); // Accept and store the integer value
                    return true;
                } else {
                    params.data.transit_time = ""; // Clear invalid input
                    return false; // Reject the change
                }
            },
            cellStyle: function (params) {
                // Highlight invalid input with a red background
                if (!Number.isInteger(Number(params.value)) || params.value === "") {
                    return {
                        backgroundColor: "#c85f62", // Red background for invalid values
                    };
                }
                return null; // No special styling for valid integers
            },
            headerClass: 'bold-header'
        }


    ]



    var tatMasterColumns1 = [
        {
            headerName: "Consigner Pincode",
            field: "consigner_pincode",
            width: 170,
            filter: true,
            resizable: true,

        },

        {
            headerName: "Consignee Pincode",
            field: "consignee_pincode",
            width: 170,
            filter: true,
            resizable: true,

        },

        {
            headerName: "Entity",
            field: "entity",
            width: 180,
            filter: true,
            resizable: true,
        }
    ]

    var [columnDefs, setColumnDefs] = useState([])
    var [consignerPincode, setConsignerPincode] = useState("")
    var [consigneePincode, setConsigneePincode] = useState("")
    var [transporterName, setTransporterName] = useState({ label: "", value: "" })
    const [editLogsData, setEditLogsData] = useState([])
    const [filteredLog, setFilteredLog] = useState([])
    const [editLogsModalOpen, setIsEditLogsModalOpen] = useState(false)

    // ---- Holiday Master state ----
    const [activeTab, setActiveTab] = useState("tat"); // default show TAT master
    const [isHolidayEdit, setIsHolidayEdit] = useState(false);
    const [editingHolidayId, setEditingHolidayId] = useState(null);
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [holidayFrom, setHolidayFrom] = useState("");
    const [holidayTo, setHolidayTo] = useState("");
    const [holidayData, setHolidayData] = useState([]);
    const [holidayTotalRecords, setHolidayTotalRecords] = useState(0); // optional for pagination
    const [holidayErrors, setHolidayErrors] = useState({});
    const [showDeleteHolidayConfirm, setShowDeleteHolidayConfirm] = useState(false);
    const [holidayToDelete, setHolidayToDelete] = useState(null);
    const holidayPageSize = 50;

    const holidayColDefs = [
        {
            headerName: "Edit",
            width: 80,
            cellRendererFramework: (params) => (
                <button
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                        setIsHolidayEdit(true);
                        setEditingHolidayId(params.data._id);

                        setHolidayForm({
                            date: params.data.holiday_date || params.data.date
                                ? new Date(params.data.holiday_date || params.data.date)
                                : null,
                            city: Array.isArray(params.data.city)
                                ? params.data.city.map(c => ({ label: c, value: c }))
                                : [],
                            state: params.data.state === "ALL STATES" ? "" : params.data.state,
                            all_states: params.data.state === "ALL STATES",
                            reason: params.data.reason
                        });

                        setHolidayErrors({});
                        setHasSubmitted(false);
                        setShowHolidayModal(true);
                    }}
                >
                    Edit
                </button>
            )
        },
        {
            headerName: "Delete",
            width: 90,
            cellRendererFramework: (params) => (
                <button
                    className="btn btn-sm btn-danger"
                    onClick={() => {
                        setHolidayToDelete(params.data);
                        setShowDeleteHolidayConfirm(true);
                    }}
                >
                    Delete
                </button>
            )
        },
        { headerName: "Date", field: "date", width: 150 },
        {
            headerName: "City",
            field: "city",
            width: 200,
            valueGetter: (params) =>
                Array.isArray(params.data.city)
                    ? params.data.city.join(", ")
                    : params.data.city || ""
        },
        { headerName: "State", field: "state", width: 150 },
        { headerName: "Reason", field: "reason", width: 250 }
    ];
    const [showHolidayModal, setShowHolidayModal] = useState(false);

    const [holidayForm, setHolidayForm] = useState({
        date: "",
        city: "",
        state: "",
        all_states: false,
        reason: ""
    });


    // function openNewHolidayModal() {
    //     setHolidayForm({
    //         date: "",
    //         city: "",
    //         state: "",
    //         all_states: false,
    //         reason: ""
    //     });
    //     setHolidayErrors({});

    //     setShowHolidayModal(true);
    // }
    function openNewHolidayModal() {
        setIsHolidayEdit(false);
        setEditingHolidayId(null);
        setHolidayForm({
            date: "",
            city: [],
            state: "",
            all_states: false,
            reason: ""
        });
        setHolidayErrors({});
        setShowHolidayModal(true);
    }
    // function validateHolidayForm() {
    //     let errors = {};

    //     const date = holidayForm.date;
    //     const city = holidayForm.city.trim();
    //     const state = holidayForm.state.trim();
    //     const allStates = holidayForm.all_states;

    //     // Normalize helper
    //     const normalizeDate = (d) => moment(d).format("YYYY-MM-DD");

    //     // REQUIRED FIELDS
    //     if (!date) errors.date = "Date is required";

    //     if (!allStates) {
    //         if (!city) errors.city = "City is required";
    //         if (!state) errors.state = "State is required";
    //     }

    //     if (!holidayForm.reason) errors.reason = "Reason is required";

    //     if (Object.keys(errors).length > 0) {
    //         setHolidayErrors(errors);
    //         return false;
    //     }

    //     if (!allStates) {
    //         const duplicate = holidayData.some(
    //             (h) =>
    //                 normalizeDate(h.date) === date &&
    //                 h.city.toLowerCase() === city.toLowerCase() &&
    //                 h.state.toLowerCase() === state.toLowerCase()
    //         );

    //         if (duplicate) {
    //             errors.city = "This City + State already exists for this date";
    //             setHolidayErrors(errors);
    //             return false;
    //         }
    //     }

    //     if (allStates) {
    //         const existingAllStates = holidayData.some(
    //             (h) =>
    //                 normalizeDate(h.date) === date &&
    //                 (
    //                     h.all_states === true ||
    //                     String(h.all_states) === "true" ||
    //                     h.state.toLowerCase() === "all states"
    //                 )
    //         );

    //         if (existingAllStates) {
    //             errors.state = "ALL STATES already exists for this date";
    //             setHolidayErrors(errors);
    //             return false;
    //         }
    //     }

    //     setHolidayErrors({});
    //     return true;
    // }
    // function validateHolidayForm() {
    //     let errors = {};

    //     const date = holidayForm.date;
    //     const city = (holidayForm.city || "").trim();
    //     const state = (holidayForm.state || "").trim();
    //     const allStates = holidayForm.all_states;

    //     console.log("[VALIDATE] values →", {
    //         date,
    //         city,
    //         state,
    //         allStates,
    //         reason: holidayForm.reason
    //     });

    //     if (!date) errors.date = "Date is required";

    //     if (!allStates) {
    //         if (!city) errors.city = "City is required";
    //         if (!state) errors.state = "State is required";
    //     }

    //     if (!holidayForm.reason) errors.reason = "Reason is required";

    //     if (Object.keys(errors).length > 0) {
    //         console.log("[VALIDATE] required-field error →", errors);
    //         setHolidayErrors(errors);
    //         return false;
    //     }

    //     const duplicateError = checkDuplicateHoliday(
    //         date,
    //         city,
    //         state,
    //         allStates
    //     );

    //     if (duplicateError) {
    //         console.log("[VALIDATE] duplicate error →", duplicateError);
    //         setHolidayErrors(
    //             allStates || city === "ALL"
    //                 ? { state: duplicateError }
    //                 : { city: duplicateError }
    //         );
    //         return false;
    //     }

    //     console.log("[VALIDATE] passed");
    //     setHolidayErrors({});
    //     return true;
    // }
    function validateHolidayForm() {
        let errors = {};

        const date = holidayForm.date;

        const cities = Array.isArray(holidayForm.city)
            ? holidayForm.city.map(c => c.value)
            : [];

        const state = (holidayForm.state || "").trim();
        const allStates = holidayForm.all_states;

        console.log("[VALIDATE] values →", {
            date,
            cities,
            state,
            allStates,
            reason: holidayForm.reason
        });
        if (!date) {
            errors.date = "Date is required";
        }

        if (!allStates) {
            if (cities.length === 0) {
                errors.city = "City is required";
            }
            if (!state) {
                errors.state = "State is required";
            }
        }

        if (!holidayForm.reason) {
            errors.reason = "Reason is required";
        }

        if (Object.keys(errors).length > 0) {
            console.log("[VALIDATE] required-field error →", errors);
            setHolidayErrors(errors);
            return false;
        }
        const duplicateError = checkDuplicateHoliday(
            date,
            cities,
            state,
            allStates,
            editingHolidayId
        );

        if (duplicateError) {
            console.log("[VALIDATE] duplicate error →", duplicateError);
            setHolidayErrors(
                allStates
                    ? { state: duplicateError }
                    : { city: duplicateError }
            );
            return false;
        }

        console.log("[VALIDATE] passed");
        // setHolidayErrors({});
        return true;
    }



    const onClickOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
        setoverlay("show-m")
    };

    const closeBulkUploadModal = () => {
        setShowBulkUploadModal(false);
        setoverlay("show-n")

    };
    const handleCloseModal = () => {
        setIsEditLogsModalOpen(false); // Close the modal
        setFilteredLog(null); // Clear filtered log
        setoverlay("show-n")
    };


    // var [showloaderbg, setshowloaderbg] = useState("show-m");
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    var [showloader, setshowloader] = useState("show-m");
    var [showAddSlider, setshowAddSlider] = useState("");
    var [overlay, setoverlay] = useState("show-n");
    var [rowid, setRowId] = useState();
    var [sliderText, setSliderText] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    var [vehicle_capacity, setvehiclecapacity] = useState("");
    var [vehicle_type, setvehicletype] = useState("");
    var [is_active, setstatus] = useState("");
    var [courierPartnerList, setCourierPartnerList] = useState([])
    const [entityList, setEntityList] = useState([]);
    const [entity, setEntity] = useState("");
    var [tptRecords, settptRecords] = useState([])
    // var modules = useState(AllModules);
    var paginationPageSize = useState(50);

    var [show, setShow] = useState(false);
    var [basicType, setBasicType] = useState("");
    var [basicTitle, setBasicTitle] = useState("");
    var [deleteConfirmationSlide, setDeleteConfirmationSlide] = useState("");
    var [deleteRowData, setDeleteRowData] = useState("");
    const [uniqueId, setUniqueId] = useState();



    const defaultColDef = useMemo(() => {
        return {
            //flex: 1,
            resizable: true,
            sortable: true,
            filter: true,
            editable: false

        };
    }, []);



    const [transporter_name, settransportername] = useState({ label: "", value: "" });
    const [consignee_pincode, setconsigneepincode] = useState("");
    const [consigner_pincode, setconsignerpincode] = useState("");
    const [transit_time, settransittime] = useState("");
    const [transitTimeError, setTransitTimeError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const pageSize = 50;


    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api
        columnApiConsignments.current = params.columnApi
    }, []);

    const getCurrentFormattedDate = () => {
        const date = new Date();
        return format(date, 'dd-MM-yyyy');
    };

    const getCurrentISODate = () => {
        const date = new Date();
        return date.toISOString();
    };
    const getDefaultHolidayRange = () => ({
        from: moment().startOf("year").format("YYYY-MM-DD"),
        to: moment().endOf("year").format("YYYY-MM-DD")
    });

    useEffect(() => {
        const { from, to } = getDefaultHolidayRange();

        setHolidayFrom(from);
        setHolidayTo(to);

        loadHolidayData(from, to);
    }, []);
    useEffect(() => {
        if (!Array.isArray(holidayData) || holidayData.length === 0) return;
        holidayData.forEach(h => {
            if (Array.isArray(h.city) && h.city.includes("ALL")) {
                console.warn(
                    "[Holiday Master] Invalid city data found (city:['ALL']) →",
                    h
                );
            }
        });
    }, [holidayData]);

    const indianStates = State.getStatesOfCountry("IN").map((s) => ({
        label: s.name,
        value: s.isoCode
    }));
    const selectedStateObj = indianStates.find(
        (s) => s.label === holidayForm.state
    );

    const cityOptions = selectedStateObj
        ? [
            { label: "ALL", value: "ALL" },
            ...City.getCitiesOfState("IN", selectedStateObj.value).map((c) => ({
                label: c.name,
                value: c.name
            }))
        ]
        : [{ label: "Select State First", value: "__disabled__", isDisabled: true }];

    const isCityAllSelected =
        Array.isArray(holidayForm.city) &&
        holidayForm.city.some(c => c.value === "ALL");

    const isAnySpecificCitySelected =
        Array.isArray(holidayForm.city) &&
        holidayForm.city.some(c => c.value !== "ALL");


    useLayoutEffect(() => {
        setTimeout(() => {
            setshowloader("show-n")
        }, 2000);
        if (currentPage === 1) {
            loadData(1);
        }
        loadHolidayData();
        try {
            redirectURL.post("/consignments/allEntityData")
                .then(resp => {
                    const records = resp.data || [];

                    const entities = [
                        ...new Set(records.map(x => x.entity))
                    ]
                        .filter(Boolean)
                        .sort()
                        .map(ent => ({
                            label: ent,
                            value: ent
                        }));

                    setEntityList(entities);
                })
                .catch(err => console.error("Entity fetch error:", err));

            redirectURL.post('/consignments/getTransportersList')
                .then(resp => {
                    const records = resp.data.tptMasterForPtl || [];

                    const tptNamesUppercase = records.map(e =>
                        (e.transporter_name || "").toUpperCase()
                    );

                    settptRecords(tptNamesUppercase);

                    const dynamicTransporterColumns = tptNamesUppercase.map(name => ({
                        headerName: name,
                        field: name,
                        width: 200,
                        filter: true,
                        editable: true,
                        resizable: true,
                        valueSetter: (params) => {
                            const newValue = params.newValue;
                            const numericValue = parseInt(newValue, 10);

                            const isNumeric = /^\d+$/.test(String(numericValue));

                            if (isNumeric && numericValue >= 0 && numericValue <= 50) {
                                params.data[params.colDef.field] = numericValue;
                                return true;
                            } else {
                                alert("Please enter a numeric transit time between 0 and 50.");
                                return false;
                            }
                        }
                    }));

                    setColumnDefs([
                        ...columnDefs1,
                        ...tatMasterColumns1,
                        ...dynamicTransporterColumns
                    ]);

                    const tptNamesList = tptNamesUppercase.map((t) => ({
                        label: t,
                        value: t
                    }));

                    setCourierPartnerList(tptNamesList);
                })
                .catch(err => console.error("Transporter list error:", err));

        } catch (error) {
            console.error("Error in useLayoutEffect:", error);
        }

    }, []); // eslint-disable-line

    var loadData = async (page) => {

        var parameters = { page, limit: pageSize };

        await redirectURL.post('/gettatDetails', parameters)
            .then(response => {
                if (response.data.status === "success") {
                    const updatedRecords = response.data.records.map(record => ({
                        ...record,
                        disabled: true
                    }));
                    setRowData(updatedRecords);
                    setTotalRecords(response.data.totalRecords); // Store total records for pagination
                    setCurrentPage(page);
                    if (gridApiConsignments.current) {
                        gridApiConsignments.current.paginationGoToPage(page - 1); // AG Grid pages start at 0
                    }
                }
                setshowloader("show-n");
            })
            .catch(error => console.error('Error fetching data:', error));
    };
    var loadPreviousData = () => {
        if (currentPage === 1) {
            let totalPages = Math.ceil(totalRecords / pageSize)
            loadData(totalPages)
        } else {
            loadData(currentPage - 1)
        }
    }
    var loadNextData = () => {
        let totalPages = Math.ceil(totalRecords / pageSize)
        if (currentPage === totalPages) {
            loadData(1)
        } else {
            loadData(currentPage + 1)
        }
    }
    var loadDatalast = () => {
        let totalPages = Math.ceil(totalRecords / pageSize)

        loadData(totalPages)
    }
    var onClickDeleteItem = async (rownode) => {
        setDeleteConfirmationSlide("slide95")
        setoverlay("show-m")
        setDeleteRowData(rownode)
    };

    var onsubmitdelete = async (rownode) => {
        const params = {
            row_id: deleteRowData.data._id
        }

        try {
            const resp = await redirectURL.post('/deleteTATDetails', params);

            if (resp.data.status === "success") {
                setDeleteConfirmationSlide("")

                setoverlay("show-n");
                setshowloader("show-n");
                setShow(true);
                setBasicTitle("TAT Deleted Successfully");
                setBasicType("success");
                loadData(1);
            }
        } catch (error) {
            console.error("Error deleting vehicle details:", error);
        }
    };
    var hideDeleteSubmit = () => {
        setDeleteConfirmationSlide("");
        setoverlay("show-n");

    }
    var onClickSaveTAT = async (rownode) => {
        const { modified_date, created_by, created_date, ...tatDataWithoutMeta } = rownode.data;

        let params = {

            tat_data: tatDataWithoutMeta,
            email: decode(localStorageEmail)

        }
        // setLoader(true)
        await redirectURL.post('/saveTATMaster', params).then((resp) => {
            if (resp.data.status == "success") {
                setoverlay("show-n");
                setshowAddSlider("");
                setshowloader("show-n");
                settransportername({ label: "", value: "" })
                setconsigneepincode("")
                setconsignerpincode("")
                settransittime("")
                setstatus("");
                setIsEditMode(false);
                setRowId("");
                setShow(true);
                setBasicTitle("Updated TAT Data");
                setBasicType("success");
                loadData(1);
            } else {
                setShow(true);
                setBasicTitle(resp.data.message);
                setBasicType("danger");
            }
        });

    }

    var showAddBlock = async (rownode) => {
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m")
        setSliderText("Add TAT");
        settransportername({ label: "", value: "" })
        setconsigneepincode("")
        setconsignerpincode("")
        settransittime("")
        setIsEditMode(false);

    }
    const onClickEditLogs = (e) => {

        const params = {
            unique_id: e.data._id,
            master_type: "tat"
        }

        redirectURL.post("/consignments/getMasterEditLogsData", params)
            .then((response) => {
                if (response.data.status == 'Success') {
                    if ((response.data.edit_logs_data).length > 0) {
                        setEditLogsData(response.data.edit_logs_data); // Store all logs
                        setFilteredLog(response.data.edit_logs_data[0]); // Default to first log
                        setIsEditLogsModalOpen(true);
                    } else {
                        setShow(true);
                        setTitle("No edit logs are currently available for this TAT.");
                        setType("danger")
                        setoverlay("show-n")
                    }

                }
            })
            .catch(function (e) {
                //console.log("Error ", e)
            })


        setoverlay("show-m");
    };

    var onClickEditBlock = async (rownode) => {
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m");
        setSliderText("Edit TAT");
        setUniqueId(rownode.data._id);
        setvehiclecapacity(rownode.data.vehicle_capacity);
        settransportername({ label: rownode.data.transporter_name, value: rownode.data.transporter_name });
        setconsigneepincode(rownode.data.consignee_pincode)
        setconsignerpincode(rownode.data.consigner_pincode)
        settransittime(rownode.data.transit_time)
        setvehicletype(rownode.data.vehicle_type);
        setIsEditMode(true);
    }

    var hideAll = () => {
        setoverlay("show-n");
        setshowAddSlider("");
        setTransitTimeError("")

    }
    const resetHolidayForm = () => {
        setHolidayForm({
            date: null,
            state: "",
            city: [],
            all_states: false,
            reason: ""
        });
        setHolidayErrors({});
    };


    // var saveMasterForm = async (e) => {
    //     e.preventDefault();
    //     let user_email = localStorage.getItem('email');
    //     // setshowloaderbg("show-m");
    //     const createdDate = getCurrentISODate();
    //     if ((consignee_pincode && !/^\d{6}$/.test(consignee_pincode)) || (consigner_pincode && !/^\d{6}$/.test(consigner_pincode))) {
    //         setShow(true);
    //         setBasicTitle("Please enter the valid pincode");
    //         setBasicType("danger");
    //         return;
    //     }
    //     if (transitTimeError !== "") {
    //         setShow(true);
    //         setBasicTitle("Please enter the valid transit time");
    //         setBasicType("danger");
    //         return;
    //     }

    //     setshowloader("show-m")

    //     // 👉 Check unique combination: consigner + consignee + entity
    //     const isDuplicate = rowData.some(r =>
    //         r.consigner_pincode == consigner_pincode &&
    //         r.consignee_pincode == consignee_pincode &&
    //         r.entity == entity
    //     );

    //     if (!isEditMode && isDuplicate) {
    //         setShow(true);
    //         setBasicType("danger");
    //         setBasicTitle("This Consigner + Consignee + Entity combination already exists!");
    //         return;
    //     }


    //     if (isEditMode) {
    //         var params = {
    //             unique_id: uniqueId,
    //             transporter_name: transporter_name.value,
    //             consignee_pincode: consignee_pincode,
    //             consigner_pincode: consigner_pincode,
    //             transit_time: transit_time,
    //             master_type: "tat",
    //             entity,
    //             email: decode(localStorageEmail)

    //             // is_active: is_active,
    //         }
    //     }
    //     else {

    //         const transporterFields = tptRecords.reduce((acc, name) => {
    //             acc[name] = name === transporter_name.value ? transit_time : "";  // use the original name as key
    //             return acc;
    //         }, {});
    //         var params = {
    //             tat_data: {
    //                 consignee_pincode: consignee_pincode,
    //                 consigner_pincode: consigner_pincode,
    //                 entity,
    //                 ...transporterFields
    //             },
    //             // is_active: is_active,
    //             email: decode(localStorageEmail),

    //         }
    //     }
    //     if (isEditMode) {
    //         await redirectURL.post('/updateTATMasterData', params).then((resp) => {
    //             if (resp.data.status == "success") {
    //                 setoverlay("show-n");
    //                 setUniqueId("");
    //                 setshowAddSlider("");
    //                 setshowloader("show-n");
    //                 settransportername({ label: "", value: "" })
    //                 setconsigneepincode("")
    //                 setconsignerpincode("")
    //                 settransittime("")
    //                 setstatus("");
    //                 setIsEditMode(false);
    //                 setRowId("");
    //                 setShow(true);
    //                 setBasicTitle("Updated TAT Data");
    //                 setBasicType("success");
    //                 loadData(1);
    //             }
    //         });
    //     } else {

    //         await redirectURL.post('/addTATData', params).then((resp) => {
    //             if (resp.data.status == "success") {
    //                 setoverlay("show-n");
    //                 setshowAddSlider("");

    //                 setIsEditMode(false);
    //                 setShow(true);
    //                 setBasicTitle("Added TAT Data");
    //                 setBasicType("success");
    //                 setTransitTimeError("")
    //                 loadData(1);
    //             } else {
    //                 setoverlay("show-n");
    //                 setshowloader("show-n");
    //                 setIsEditMode(false);
    //                 setshowAddSlider("");
    //                 settransportername({ label: "", value: "" })
    //                 setconsigneepincode("")
    //                 setconsignerpincode("")
    //                 settransittime("")
    //                 setstatus("");
    //                 setShow(true);
    //                 setBasicTitle(resp.data.message);
    //                 setTransitTimeError("")

    //                 setBasicType("danger");
    //             }
    //         }).catch(err => {
    //         });


    //     }
    // };

    const saveMasterForm = async (e) => {
        e.preventDefault();
        if ((consignee_pincode && !/^\d{6}$/.test(consignee_pincode)) ||
            (consigner_pincode && !/^\d{6}$/.test(consigner_pincode))) {
            setShow(true);
            setBasicTitle("Please enter valid 6-digit pincodes");
            setBasicType("danger");
            return;
        }
        if (transitTimeError !== "") {
            setShow(true);
            setBasicTitle("Please enter a valid transit time between 0 and 50");
            setBasicType("danger");
            return;
        }

        if (!entity || entity.trim() === "") {
            setShow(true);
            setBasicTitle("Entity is mandatory");
            setBasicType("danger");
            return;
        }

        if (!isEditMode) {
            const isDuplicate = rowData.some(r =>
                r.consigner_pincode == consigner_pincode &&
                r.consignee_pincode == consignee_pincode &&
                (r.entity || "") == entity
            );

            if (isDuplicate) {
                setShow(true);
                setBasicType("danger");
                setBasicTitle("This Consigner + Consignee + Entity combination already exists!");
                return;
            }
        }

        setshowloader("show-m");
        const transporterFields = tptRecords.reduce((acc, name) => {
            if (isEditMode) {
                const row = rowData.find(r => r._id === uniqueId);
                acc[name] = row?.[name] ?? "";
            } else {
                acc[name] = (name === transporter_name.value) ? transit_time : "";
            }
            return acc;
        }, {});

        let params = {};

        if (!isEditMode) {
            params = {
                tat_data: {
                    consigner_pincode,
                    consignee_pincode,
                    transporter_name: transporter_name.value,
                    transit_time,
                    entity,
                    ...transporterFields
                },
                master_type: "tat",
                email: decode(localStorageEmail)
            };
        }
        if (isEditMode) {
            params = {
                tat_data: {
                    _id: uniqueId,
                    consigner_pincode,
                    consignee_pincode,
                    transporter_name: transporter_name.value,
                    transit_time,
                    entity,
                    ...transporterFields
                },
                master_type: "tat",
                email: decode(localStorageEmail)
            };
        }

        await redirectURL.post("/addTATData", params)
            .then((resp) => {
                setshowloader("show-n");

                if (resp.data.status === "success") {

                    hideAll();
                    setShow(true);
                    setBasicType("success");
                    setBasicTitle(isEditMode ? "Updated TAT Successfully" : "Added TAT Successfully");

                    settransportername({ label: "", value: "" });
                    setconsigneepincode("");
                    setconsignerpincode("");
                    settransittime("");
                    setEntity("");
                    setIsEditMode(false);

                    loadData(1);
                } else {
                    setShow(true);
                    setBasicType("danger");
                    setBasicTitle(resp.data.message || "Error in saving TAT");
                }
            })
            .catch(() => {
                setshowloader("show-n");
                setShow(true);
                setBasicType("danger");
                setBasicTitle("Server Error saving TAT");
            });
    };

    const loadHolidayData = async (from, to) => {
        try {
            setshowloader("show-m");

            const from_date = (from || holidayFrom || "").trim();
            const to_date = (to || holidayTo || "").trim();

            if (!from_date || !to_date) {
                setHolidayData([]);
                setshowloader("show-n");
                return;
            }

            const req = {
                from_date: moment(from_date).format("YYYY-MM-DD"),
                to_date: moment(to_date).format("YYYY-MM-DD")
            };

            const resp = await redirectURL.post(
                "/consignments/getHolidayData",
                req
            );

            if (resp?.data?.status === "success") {
                setHolidayData(resp.data.records || []);
            } else {
                setHolidayData([]);
            }
        } catch (err) {
            console.error("[Holiday] loadHolidayData error:", err);
            setHolidayData([]);
        }
        setshowloader("show-n");
    };
    const resetHolidayFilters = () => {
        setshowloader("show-m");
        const { from, to } = getDefaultHolidayRange();

        setHolidayFrom(from);
        setHolidayTo(to);

        loadHolidayData(from, to)
            .finally(() => {
                setshowloader("show-n");
            });
    };





    // function normalizeHolidayDate(inputDate) {
    //     const m = moment(inputDate, [
    //         "DD-MM-YYYY",
    //         "MM-DD-YYYY",   
    //         "YYYY-MM-DD",
    //         "DD/MM/YYYY",
    //         "MM/DD/YYYY",
    //         "YYYY/MM/DD",
    //         "DD-MMM-YYYY",
    //         "D-MMM-YYYY",
    //         "DD-MMM-YY",
    //         "D-MMM-YY"
    //     ], true);

    //     if (!m.isValid()) return "";

    //     // 👉 Change format here to what DB expects
    //     return m.format("YYYY-MM-DD");
    // }
    const checkDuplicateHoliday = (
        date,
        cities,
        state,
        allStates,
        editingId = null
    ) => {
        if (!date) return null;

        const normalizedDate = moment(date).format("YYYY-MM-DD");

        for (const h of holidayData) {
            if (editingId && h._id === editingId) continue;
            const hDate = moment(h.holiday_date || h.date).format("YYYY-MM-DD");
            if (hDate !== normalizedDate) continue;

            const hIsAllStates =
                h.all_states === true ||
                String(h.all_states) === "true" ||
                h.state === "ALL STATES";
            const hCities = Array.isArray(h.city)
                ? h.city
                : h.city
                    ? [h.city]
                    : [];

            if (allStates && hIsAllStates) {
                return "ALL STATES holiday already exists for this date";
            }
            if (!allStates && hIsAllStates) {
                return "ALL STATES holiday already exists for this date";
            }
            if (allStates && !hIsAllStates) {
                return "Cannot add ALL STATES when holidays already exist for this date";
            }
            if (!allStates) {
                if (h.state?.toLowerCase() !== state.toLowerCase()) continue;
                if (hCities.includes("ALL") || cities.includes("ALL")) {
                    return "Holiday already exists for this date";
                }
                const overlap = hCities.some(c =>
                    cities.some(nc => nc.toLowerCase() === c.toLowerCase())
                );

                if (overlap) {
                    return "Holiday already exists for this City and State";
                }
            }
        }

        return null;
    };
    // async function saveHoliday() {
    //     console.log("Save clicked");
    //     if (!validateHolidayForm()) {
    //         console.log("Validation failed");
    //         return;
    //     }
    //     setshowloader("show-m");
    //     const formattedDate = holidayForm.date
    //         ? moment(holidayForm.date).format("YYYY-MM-DD")
    //         : "";

    //     const payload = {
    //         record: {
    //             date: formattedDate,
    //             city: holidayForm.all_states ? "" : holidayForm.city,
    //             state: holidayForm.all_states ? "ALL STATES" : holidayForm.state,
    //             reason: holidayForm.reason,
    //             all_states: holidayForm.all_states
    //         },
    //         email: decode(localStorageEmail)
    //     };

    //     const resp = await redirectURL.post("/consignments/saveHoliday", payload);
    //     setshowloader("show-n");
    //     if (resp.data.status === "success") {
    //         setShowHolidayModal(false);
    //         loadHolidayData(holidayFrom, holidayTo);
    //         setShow(true);
    //         setBasicTitle("Holiday Added Successfully");
    //         setBasicType("success");
    //     } else {
    //         setShow(true);
    //         setBasicTitle(resp.data.message || "Error saving holiday");
    //         setBasicType("danger");
    //     }
    // }
    async function saveHoliday() {
        setHasSubmitted(true);
        const isValid = validateHolidayForm();

        if (!isValid) {
            return;
        }
        setshowloader("show-m");

        const payload = {
            record: {
                _id: isHolidayEdit ? editingHolidayId : undefined,
                date: moment(holidayForm.date).format("YYYY-MM-DD"),
                city: holidayForm.all_states
                    ? ""
                    : holidayForm.city.map(c => c.value),
                state: holidayForm.all_states ? "ALL STATES" : holidayForm.state,
                reason: holidayForm.reason,
                all_states: holidayForm.all_states
            },
            action: isHolidayEdit ? "UPDATE" : "CREATE",
            email: decode(localStorageEmail)
        };

        const resp = await redirectURL.post(
            "/consignments/saveHoliday",
            payload
        );
        setshowloader("show-n");
        if (resp.data.status === "success") {
            setShowHolidayModal(false);
            setIsHolidayEdit(false);
            setEditingHolidayId(null);
            loadHolidayData(holidayFrom, holidayTo);
        } else {
            setHolidayErrors({ form: resp.data.message });
        }
    }
    const confirmDeleteHoliday = async () => {
        if (!holidayToDelete) return;
        setShowDeleteHolidayConfirm(false);
        setshowloader("show-m");
        const payload = {
            record: { _id: holidayToDelete._id },
            action: "DELETE",
            email: decode(localStorageEmail)
        };

        const resp = await redirectURL.post(
            "/consignments/saveHoliday",
            payload
        );
        setshowloader("show-n");
        if (resp.data.status === "success") {
            loadHolidayData(holidayFrom, holidayTo);
            setShow(true);
            setBasicType("success");
            setBasicTitle("Holiday deleted successfully");
        } else {
            setShow(true);
            setBasicType("danger");
            setBasicTitle(resp.data.message);
        }
        setHolidayToDelete(null);
    };
    const toTitleCase = (text) => {
        return text
            .toLowerCase()
            .replace(/\b\w/g, char => char.toUpperCase());
    };


    var handleTransporterName = (e) => {
        settransportername(e)
    };
    var onClickSubmitFilter = async () => {

        const params = {
            consigner_pincode: consignerPincode,
            consignee_pincode: consigneePincode,
            // transporter_name: transporterName.value
        }
        if (consigneePincode !== "" && consignerPincode !== "") {
            await redirectURL.post('/tatMasterFilter', params).then((resp) => {
                if (resp.data.status == "success") {
                    const updatedRecords = resp.data.records.map(record => ({
                        ...record,
                        disabled: true
                    }));
                    setRowData(updatedRecords);

                    // loadData(1);
                }
            });
        } else {
            setShow(true);
            setBasicTitle("Please select all mandatory fields");
            setBasicType("danger");
        }
    }
    var onClickResetFilter = async () => {
        setTransporterName({ label: "", value: "" })
        setConsigneePincode("")
        setConsignerPincode("")

        loadData(1)
    }

    const handleTransitTime = (e) => {
        const value = e.target.value;

        // Validate if the input is numeric (only numbers)
        if (/^\d*\.?\d*$/.test(value) && value >= 0 && value <= 50) {
            settransittime(value); // Update state with valid numeric value
            setTransitTimeError(""); // Clear the error message
        } else {
            setTransitTimeError("Please enter a valid numeric value between 0 and 50"); // Show error for invalid input
        }
    };
    const handleEditable = (params) => {
        setRowData(prevUsers =>
            prevUsers.map(row =>
                row._id === params.data._id ? { ...row, disabled: false } : row
            )
        );
    }
    // Disable Sundays
    // const isNotSunday = (date) => {
    //     return date.getDay() !== 0;
    // };

    // const getMinSelectableDate = () => {
    //     if (isHolidayEdit && holidayForm.date) {
    //         return new Date(holidayForm.date);
    //     }
    //     return new Date();
    // };
    const getMinSelectableDate = () => {
        return new Date(); // always today
    };
    return (
        <div>
            <div className="container-fluid">
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={() => {
                        setShow(false)
                    }}>
                </SweetAlert>
                <SweetAlert
                    show={showDeleteHolidayConfirm}
                    warning
                    showCancel
                    title="Delete Holiday"
                    confirmBtnText="Yes, Delete"
                    cancelBtnText="Cancel"
                    onConfirm={confirmDeleteHoliday}
                    onCancel={() => {
                        setShowDeleteHolidayConfirm(false);
                        setHolidayToDelete(null);
                    }}
                    confirmBtnCssClass="btn btn-sm btn-danger"
                    cancelBtnCssClass="btn btn-sm btn-light"
                >
                    Are you sure you want to delete this holiday?
                </SweetAlert>

            </div>
            <h5 className="f18 d-flex align-items-center master-title ml-3">
                {/* <i className="icofont icofont-vehicle-delivery-van cus-i"></i>&nbsp; */}
                ETA Master
            </h5>
            <div className="container-fluid mb-2">
                <div className="row">
                    <div className="col-auto">
                        <button
                            className={`btn ${activeTab === "tat" ? "btn-primary" : "btn-light"} mr-2`}
                            onClick={() => setActiveTab("tat")}
                        >
                            TAT Master
                        </button>

                        <button
                            className={`btn ${activeTab === "holiday" ? "btn-primary" : "btn-light"}`}
                            onClick={() => {
                                setActiveTab("holiday");
                                loadHolidayData();
                            }}

                        >
                            Holiday Master
                        </button>
                        <button
                            className={`btn ${activeTab === "transit" ? "btn-primary" : "btn-light"} ml-2`}
                            onClick={() => setActiveTab("transit")}
                        >
                            Transit Days Buffer Master
                        </button>
                        <button
                            className={`btn ${activeTab === "zonebuffer" ? "btn-primary" : "btn-light"} ml-2`}
                            onClick={() => setActiveTab("zonebuffer")}
                        >
                            Zone Wise Buffer Master
                        </button>
                        <button
                            className={`btn ${activeTab === "seasonalbuffer" ? "btn-primary" : "btn-light"} ml-2`}
                            onClick={() => setActiveTab("seasonalbuffer")}
                        >
                            Seasonal Buffer Master
                        </button>
                        <button
                            className={`btn ${activeTab === "delaycategory" ? "btn-primary" : "btn-light"} ml-2`}
                            onClick={() => setActiveTab("delaycategory")}
                        >
                            Delay Category Master
                        </button>


                    </div>
                </div>
            </div>
            {activeTab === "tat" && (
                <div className="container-fluid">
                    {/* Row for Header and Buttons */}
                    <div className="row align-items-center justify-content-between mb-3">
                        {/* Heading */}
                        {/* <div className="col-auto">
                            <h5 className="f18 d-flex align-items-center master-title">
                                <i className="icofont icofont-vehicle-delivery-van cus-i"></i>&nbsp;TAT Master
                            </h5>
                        </div> */}

                        {/* Buttons */}
                        <div className="col-auto d-flex">
                            {/* <button
                                title="Bulk Upload"
                                onClick={onClickOpenBulkUploadModal}
                                className="btn btn-warning mr-2"
                                type="button"
                                style={{ padding: "8px 15px", height: "35px" }}
                            >
                                <i className="fa fa-upload"></i>&nbsp;Upload TAT's
                            </button> */}

                            <BulkUploadModal
                                show={showBulkUploadModal}
                                onClose={closeBulkUploadModal}
                                columnDefs={tatMasterColumns}
                                screen={"tat_master"}
                                templateUrl={require('../../assets/json/tat_master_template.csv')}
                            />
                            <CustomDialogForMasterEditLogs
                                isOpen={editLogsModalOpen}
                                onClose={handleCloseModal}
                                editLogsData={editLogsData}
                                filteredLog={filteredLog}
                                setFilteredLog={setFilteredLog}
                            />
                            {/* {Constants.VEHICLES.BTN_ADD === 1 && (
                                <button
                                    className="btn btn-warning"
                                    onClick={showAddBlock}
                                    style={{ padding: "8px 15px", height: "35px" }}
                                >
                                    <i className="icon-plus"></i>&nbsp;Add TAT
                                </button>
                            )} */}
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="row">
                        <div className="col-xl-12 col-md-12 xl-60">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className={" col-xl-2 col-lg-2 form-group"}>

                                            <label style={{ fontWeight: "700", fontSize: "13px" }}>Consigner Pincode<span style={{ color: 'red' }}>*</span></label>
                                            <input
                                                type="text"
                                                name="consigner_pincode"
                                                id="consignerPincode"
                                                placeholder={"Consigner Pincode"}
                                                autoComplete="off"
                                                className="form-control"
                                                value={consignerPincode}
                                                style={{ fontSize: "13px", padding: "7px" }}
                                                onChange={(e) => setConsignerPincode(e.target.value)}
                                                maxLength={6}
                                            />

                                            {consignerPincode && !/^\d{6}$/.test(consignerPincode) && (
                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                    Pincode must be exactly 6 digits
                                                </span>
                                            )}

                                        </div>
                                        <div className={" col-xl-2 col-lg-2 form-group"}>
                                            <label style={{ fontWeight: "700", fontSize: "13px" }}>Consignee Pincode<span style={{ color: 'red' }}>*</span></label>
                                            <input
                                                type="text"
                                                name="consignee_pincode"
                                                id="consigneePincode"
                                                placeholder={"Consignee Pincode"}
                                                autoComplete="off"
                                                className="form-control"
                                                value={consigneePincode}
                                                style={{ fontSize: "13px", padding: "7px" }}
                                                onChange={(e) => setConsigneePincode(e.target.value)}
                                                maxLength={6} />
                                            {consigneePincode && !/^\d{6}$/.test(consigneePincode) && (
                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                    Pincode must be exactly 6 digits
                                                </span>
                                            )}
                                        </div>
                                        {/* <div class={" col-xl-3 col-lg-3 form-group"}>
								                <label style={{fontWeight:"700", fontSize:"13px"}}>Transporter Name<span style={{color: 'red'}}>*</span></label>
                                                 <Select
                                                    closeMenuOnSelect={true}
                                                    value={transporterName}
                                                    onChange={(e)=>
                                                        setTransporterName(e)
                                                    }
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    options={courierPartnerList}
                                                    // isDisabled={true}

                                                />
							                </div> */}

                                        <div className="col-xl-2 col-lg-2 form-group" style={{ paddingTop: "30px" }}>
                                            <label></label>
                                            <button type="submit" onClick={onClickSubmitFilter} class="btn btn-success">Get Data</button>
                                            &nbsp;
                                            <button type="submit" onClick={onClickResetFilter} class="btn btn-default">Reset</button>

                                        </div>
                                        <div className="col-xl-6 col-lg-6 form-group" style={{ paddingTop: "30px" }}>
                                            <div className="d-flex justify-content-end">
                                                {Constants.VEHICLES.BTN_ADD === 1 && (
                                                    <button
                                                        className="btn btn-primary"
                                                        onClick={showAddBlock}
                                                        style={{
                                                            width: "100px",
                                                            height: "40px",
                                                            fontSize: "13px",
                                                            borderRadius: "4px",
                                                            // fontWeight: "500"
                                                        }}
                                                    >
                                                        + Add TAT
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="ag-theme-balham mt-3"
                                        style={{ height: "500px", width: "100%" }}
                                    >
                                        <AgGridReact
                                            onCellEditingStarted={handleEditable}
                                            columnDefs={columnDefs}
                                            rowData={rowData}
                                            defaultColDef={defaultColDef}
                                            pagination={true}
                                            paginationPageSize={pageSize}
                                            paginationAutoPageSize={false}
                                            suppressPaginationPanel={true}
                                            onGridReady={onGridReadyConsignments}
                                            enableRangeSelection={true}
                                            enableCellContextMenu={true}
                                            masterDetail={true}
                                            context={{ onClickEditBlock, onClickDeleteItem }}
                                            sideBar={{
                                                toolPanels: [
                                                    {
                                                        id: "columns",
                                                        labelDefault: "Columns",
                                                        labelKey: "columns",
                                                        iconKey: "columns",
                                                        toolPanel: "agColumnsToolPanel",
                                                        toolPanelParams: {
                                                            suppressPivotMode: true,
                                                            suppressRowGroups: true,
                                                            suppressValues: true,
                                                        },
                                                    },
                                                    {
                                                        id: "filters",
                                                        labelDefault: "Filters",
                                                        labelKey: "filters",
                                                        iconKey: "filter",
                                                        toolPanel: "agFiltersToolPanel",
                                                    },
                                                ],
                                            }}
                                            statusBar={{
                                                statusPanels: [
                                                    {
                                                        statusPanel: "agTotalAndFilteredRowCountComponent",
                                                        align: "left",
                                                    },
                                                    {
                                                        statusPanel: "agTotalRowCountComponent",
                                                        align: "center",
                                                    },
                                                    { statusPanel: "agFilteredRowCountComponent" },
                                                    { statusPanel: "agSelectedRowCountComponent" },
                                                    { statusPanel: "agAggregationComponent" },
                                                ],
                                            }}
                                        />
                                    </div>
                                    <div className="pagination-controls">
                                        <span
                                            onClick={() => {

                                                loadData(1)
                                            }}
                                            style={{ cursor: "pointer", marginRight: "5px" }}
                                        >
                                            {"<"}
                                        </span>
                                        <button
                                            // disabled={currentPage === 1} 
                                            // onClick={() => loadData(currentPage - 1)}
                                            onClick={loadPreviousData}
                                        >
                                            Previous
                                        </button>

                                        <span>
                                            Page {currentPage} of {Math.ceil(totalRecords / pageSize)}
                                            | Total Records:{totalRecords.toLocaleString("en-IN")}
                                        </span>
                                        <button
                                            // disabled={currentPage * pageSize >= totalRecords} 
                                            onClick={loadNextData}
                                        >
                                            Next
                                        </button>
                                        <span
                                            onClick={() => {

                                                loadDatalast()
                                            }}
                                            style={{ cursor: "pointer", marginRight: "5px" }}
                                        >
                                            {">"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className={"overlay-part " + (overlay)} onClick={hideAll}></div>

            <div className={"slide-r " + showAddSlider}>
                <div className="slide-r-title">
                    <h4 className="slide-r-title">{sliderText}
                        <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={hideAll} >X</span>

                    </h4>

                </div>
                <div className="slide-r-body">

                    <form className="" style={{ padding: "20px" }} onSubmit={saveMasterForm}>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Consigner Pincode<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="consigner_pincode" value={consigner_pincode} style={{
                                width: "100%",
                                padding: "8px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                            }}
                                autoComplete='off'
                                onChange={(e) => setconsignerpincode(e.target.value)}
                                maxLength={6}
                                required={!isEditMode}

                                disabled={isEditMode}
                            />
                            {consigner_pincode && !/^\d{6}$/.test(consigner_pincode) && (
                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                    Pincode must be exactly 6 digits
                                </span>
                            )}
                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Consignee Pincode<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="consignee_pincode" value={consignee_pincode} style={{
                                width: "100%",
                                padding: "8px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                            }}
                                autoComplete='off'
                                onChange={(e) => setconsigneepincode(e.target.value)}
                                maxLength={6}
                                required={!isEditMode}


                                disabled={isEditMode}
                            />
                            {consignee_pincode && !/^\d{6}$/.test(consignee_pincode) && (
                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                    Pincode must be exactly 6 digits
                                </span>
                            )}
                        </div>
                        {/* {pincodeError!==""&& 
                        <div style={{ color: "red", fontSize: "12px", paddingTop: "5px", paddingLeft: "20px" }}>
                            {pincodeError}
                        </div>} */}

                        {/* {pincodeError1!==""&& 
                            <div style={{ color: "red", fontSize: "12px", paddingTop: "5px", paddingLeft: "20px" }}>
                                 {pincodeError1}
                            </div>} */}

                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Transporter Name<span style={{ color: 'red' }}>*</span></label>
                            <Select
                                closeMenuOnSelect={true}
                                value={transporter_name}
                                // multi={true}
                                // className={"border-radius-0"} 
                                onChange={handleTransporterName}
                                options={courierPartnerList}
                                // style={{ borderRadius: "0px" }}
                                isDisabled={isEditMode}
                                required={!isEditMode}

                            >
                            </Select>

                        </div>

                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Transit Time<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="transit_time" value={transit_time} style={{
                                width: "100%",
                                padding: "8px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                            }}
                                autoComplete='off'
                                onChange={handleTransitTime}
                                required={!isEditMode}
                            />
                            {transitTimeError !== "" && (
                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                    {transitTimeError}
                                </span>
                            )}
                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>
                                Entity <span style={{ color: 'red' }}>*</span>
                            </label>
                            <Select
                                options={entityList}
                                value={entityList.find(x => x.value === entity)}
                                onChange={(e) => setEntity(e.value)}
                                isDisabled={isEditMode}
                                required={!isEditMode}
                            />
                        </div>




                        {isEditMode ?
                            <>
                                <div className="form-group" style={{ textAlign: "center" }}>
                                    <button type="submit" className="btn btn-success"
                                        style={{
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "4px",
                                            backgroundColor: "#28a745",
                                            color: "white",
                                        }}
                                    >Update TAT</button>
                                </div>
                            </>
                            :
                            <>
                                <div className="form-group" style={{ textAlign: "center" }}>
                                    <button type="submit" className="btn btn-success"
                                        style={{
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "4px",
                                            backgroundColor: "#28a745",
                                            color: "white",
                                        }}
                                    >Add TAT</button>
                                </div>
                            </>
                        }
                        {/* <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add Transporter</button>
                        </div> */}

                    </form>
                </div>

            </div>
            {deleteConfirmationSlide
                &&
                <div className={"sliderBlock3 " + (deleteConfirmationSlide)} >
                    <span className="float-right ffclosebtn1" style={{ marginRight: "25px", fontSize: '20px' }} onClick={hideDeleteSubmit} >
                        <img src={require('../../assets/images/closeIcon.png')} className='closeIcon mt-5p' style={{ marginTop: "-40px" }} />
                    </span>
                    <div className='d-flex mt-60p' style={{ marginLeft: "42px" }}>
                        <div className='d-flex flex-column ml-20p'>
                            <h1 className='confirm-heading'>Are you sure you want to delete ?</h1>
                        </div>
                    </div>
                    <div className='d-flex flex-row ml-30p mt-20p'>
                        <button className='btn_confirm_cancel' style={{ marginRight: "36px", marginLeft: "15px" }} onClick={hideDeleteSubmit} >Cancel</button>
                        <button className='btn_hover8' onClick={onsubmitdelete}>Delete</button>
                    </div>

                </div>}


            {/* HOLIDAY MASTER UI */}
            {activeTab === "holiday" && (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-12 col-md-12 xl-60">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row align-items-end">

                                        <div className="col-xl-2 col-lg-2 form-group">
                                            <label style={{ fontWeight: "700", fontSize: "13px" }}>From Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={holidayFrom}
                                                onChange={(e) => setHolidayFrom(e.target.value)}
                                            />
                                        </div>

                                        <div className="col-xl-2 col-lg-2 form-group">
                                            <label style={{ fontWeight: "700", fontSize: "13px" }}>To Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={holidayTo}
                                                onChange={(e) => setHolidayTo(e.target.value)}
                                            />
                                        </div>

                                        <div className="col-xl-3 col-lg-3 form-group d-flex" style={{ paddingTop: "30px" }}>
                                            <button
                                                className="btn btn-success"
                                                onClick={() => loadHolidayData(holidayFrom, holidayTo)}
                                            >
                                                Get Data
                                            </button>
                                            &nbsp;
                                            <button className="btn btn-default" onClick={resetHolidayFilters}>
                                                Reset
                                            </button>
                                        </div>

                                        <div className="col-xl-5 col-lg-5 d-flex justify-content-end form-group" style={{ paddingTop: "30px" }}>
                                            <button className="btn btn-primary" onClick={openNewHolidayModal}>
                                                + Add Holiday
                                            </button>
                                        </div>

                                    </div>

                                    <div className="ag-theme-balham mt-3" style={{ height: "500px", width: "100%" }}>
                                        <AgGridReact
                                            rowData={holidayData}
                                            columnDefs={holidayColDefs}
                                            defaultColDef={{
                                                resizable: true,
                                                sortable: true,
                                                filter: true,
                                                cellStyle: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: "14px"
                                                }
                                            }}
                                            pagination={true}
                                            paginationPageSize={20}
                                            rowHeight={32}
                                            sideBar={{
                                                toolPanels: [
                                                    {
                                                        id: "columns",
                                                        labelDefault: "Columns",
                                                        labelKey: "columns",
                                                        iconKey: "columns",
                                                        toolPanel: "agColumnsToolPanel"
                                                    },
                                                    {
                                                        id: "filters",
                                                        labelDefault: "Filters",
                                                        labelKey: "filters",
                                                        iconKey: "filter",
                                                        toolPanel: "agFiltersToolPanel"
                                                    }
                                                ],
                                                defaultToolPanel: ""
                                            }}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showHolidayModal && (
                <>
                    {/* <div className="modalOverlay" onClick={() => setShowHolidayModal(false)}></div> */}
                    <div
                        className="modalOverlay"
                        onClick={() => {
                            setShowHolidayModal(false);
                            setIsHolidayEdit(false);
                            setEditingHolidayId(null);
                            setHolidayErrors({});
                            setHasSubmitted(false);
                        }}
                    ></div>

                    <div className="rightModal">

                        <button
                            className="close"
                            onClick={() => {
                                setShowHolidayModal(false);
                                setIsHolidayEdit(false);
                                setEditingHolidayId(null);
                                setHolidayErrors({});
                            }}
                            style={{
                                position: "absolute",
                                top: "15px",
                                right: "15px",
                                fontSize: "26px",
                                fontWeight: "700",
                                border: "none",
                                background: "transparent",
                                cursor: "pointer"
                            }}
                        >
                            &times;
                        </button>

                        <div
                            style={{
                                backgroundColor: "#1F6F8B",
                                color: "white",
                                padding: "12px 0",
                                textAlign: "center",
                                fontSize: "18px",
                                fontWeight: "600",
                                // borderTopLeftRadius: "8px",
                                // borderTopRightRadius: "8px",
                                position: "relative",
                                margin: "-20px -20px 20px -20px"
                            }}
                        >
                            {isHolidayEdit ? "Edit Holiday" : "Add Holiday"}

                            <button
                                onClick={() => {
                                    setShowHolidayModal(false);
                                    setIsHolidayEdit(false);
                                    setEditingHolidayId(null);
                                    setHolidayErrors({});
                                }}
                                style={{
                                    position: "absolute",
                                    right: "15px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "50%",
                                    border: "none",
                                    backgroundColor: "#0B3C5D",
                                    color: "white",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    cursor: "pointer",
                                    lineHeight: "32px",
                                    textAlign: "center",
                                    padding: 0
                                }}
                            >
                                X
                            </button>
                        </div>
                        <div className="form-group mb-3" style={{ width: "100%" }}>
                            <label>Date <span style={{ color: 'red' }}>*</span></label>

                            {/* <div style={{ width: "100%" }}> */}
                            {/* <DatePicker
                                    selected={holidayForm.date ? new Date(holidayForm.date) : null}
                                    onChange={(date) => {
                                        if (!date) {
                                            setHolidayForm(prev => ({ ...prev, date: null }));
                                            return;
                                        }

                                        if (date.getDay() === 0) {
                                            setHolidayErrors(prev => ({
                                                ...prev,
                                                date: "Sunday is not allowed. Please choose another date."
                                            }));
                                            return;
                                        }

                                        const error = checkDuplicateHoliday(
                                            date,
                                            holidayForm.city,
                                            holidayForm.state,
                                            holidayForm.all_states
                                        );

                                        setHolidayForm(prev => ({ ...prev, date }));
                                        setHolidayErrors(prev => ({
                                            ...prev,
                                            date: error || ""
                                        }));
                                    }}
                                    dateFormat="yyyy-MM-dd"
                                    placeholderText="Select date"
                                    className="form-control"
                                    filterDate={(date) => date.getDay() !== 0}
                                    wrapperClassName="w-100"   // ← THIS FIXES WIDTH
                                /> */}
                            <DatePicker
                                selected={holidayForm.date}
                                onChange={(date) =>
                                    setHolidayForm(prev => ({ ...prev, date }))
                                }
                                className="form-control"
                                dateFormat="dd-MM-yyyy"
                                minDate={getMinSelectableDate()}
                                // filterDate={isNotSunday}
                                placeholderText="Select Date"
                                wrapperClassName="w-100"
                            />
                            { }
                            {hasSubmitted && holidayErrors.date && (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                    {holidayErrors.date}
                                </span>
                            )}
                        </div>
                        <div>
                            <label>State <span style={{ color: 'red' }}>*</span></label>
                            <Select
                                className="mb-3"
                                isDisabled={holidayForm.all_states}
                                options={indianStates}
                                value={
                                    holidayForm.state
                                        ? { label: holidayForm.state, value: holidayForm.state }
                                        : null
                                }
                                onChange={(selected) => {
                                    if (!selected) return;

                                    setHolidayForm(prev => ({
                                        ...prev,
                                        state: selected.label,
                                        city: [],
                                        all_states: false
                                    }));

                                    setHolidayErrors(prev => ({
                                        ...prev,
                                        state: ""
                                    }));
                                }}
                            />

                            {hasSubmitted && holidayErrors.state && (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                    {holidayErrors.state}
                                </span>
                            )}
                        </div>

                        <label>City <span style={{ color: 'red' }}>*</span></label>
                        {/* <Select
                            className="mb-3"
                            isDisabled={!holidayForm.state || holidayForm.all_states}
                            options={cityOptions}
                            value={
                                holidayForm.city
                                    ? { label: holidayForm.city, value: holidayForm.city }
                                    : null
                            }
                            onChange={(selected) => {
                                const error = checkDuplicateHoliday(
                                    holidayForm.date,
                                    selected.value,
                                    holidayForm.state,
                                    false 
                                );

                                setHolidayForm(prev => ({
                                    ...prev,
                                    city: selected.value,   
                                    all_states: false       
                                }));

                                setHolidayErrors({
                                    ...holidayErrors,
                                    state: error || ""
                                });
                            }}
                        /> */}
                        <Select
                            isMulti
                            options={cityOptions}
                            value={holidayForm.city}
                            isDisabled={holidayForm.all_states || !holidayForm.state}
                            placeholder={
                                holidayForm.all_states
                                    ? "Disabled (All States selected)"
                                    : !holidayForm.state
                                        ? "Select State first"
                                        : "Select City"
                            }
                            onChange={(selected) => {
                                if (selected.some(c => c.value === "ALL")) {
                                    setHolidayForm({
                                        ...holidayForm,
                                        city: [{ label: "ALL", value: "ALL" }]
                                    });
                                } else {
                                    setHolidayForm({
                                        ...holidayForm,
                                        city: selected.filter(c => c.value !== "__disabled__")
                                    });
                                }
                            }}
                            isOptionDisabled={(option) =>
                                isCityAllSelected && option.value !== "ALL"
                            }
                        />
                        {hasSubmitted && holidayErrors.city && (
                            <span style={{ color: "red", fontSize: "12px" }}>
                                {holidayErrors.city}
                            </span>
                        )}
                        <div className="mt-2 mb-4">
                            <input
                                type="checkbox"
                                checked={holidayForm.all_states}
                                disabled={!!holidayForm.state}
                                onChange={(e) => {
                                    const checked = e.target.checked;

                                    setHolidayForm({
                                        ...holidayForm,
                                        all_states: checked,
                                        state: "",
                                        city: []
                                    });
                                }}
                            />{" "}
                            <span style={{ fontWeight: "500" }}>ALL States</span>
                            {holidayErrors.state && (
                                <div style={{ color: "red", fontSize: "13px", marginTop: "6px" }}>
                                    {holidayErrors.state}
                                </div>
                            )}
                        </div>

                        <label>Reason <span style={{ color: 'red' }}>*</span></label>
                        <textarea
                            className="form-control mb-1"
                            rows="3"
                            value={holidayForm.reason}
                            onChange={(e) => {
                                const formatted = toTitleCase(e.target.value);
                                setHolidayForm({ ...holidayForm, reason: formatted });
                                setHolidayErrors(prev => ({ ...prev, reason: "" }));
                            }}
                        />
                        {hasSubmitted && holidayErrors.reason && (
                            <span style={{ color: "red", fontSize: "12px" }}>
                                {holidayErrors.reason}
                            </span>
                        )}

                        <div
                            style={{
                                marginTop: "20px",
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center"
                            }}
                        >
                            <button
                                className="btn"
                                style={{
                                    width: "100px",
                                    height: "40px",
                                    fontSize: "15px",
                                    marginRight: "4px",
                                    backgroundColor: "#a6a7a8ff", borderColor: "#a6a7a8ff",
                                    borderRadius: "5px"
                                }}
                                onClick={resetHolidayForm}
                            >
                                Reset
                            </button>
                            <button
                                className="btn btn-secondary"
                                style={{
                                    width: "120px",
                                    height: "40px",
                                    fontSize: "15px",
                                    marginRight: "4px"
                                }}
                                onClick={() => {
                                    setShowHolidayModal(false);
                                    setHolidayErrors({});
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                className="btn btn-success"
                                style={{
                                    width: "120px",
                                    height: "40px",
                                    fontSize: "15px",
                                    borderRadius: "5px"
                                }}
                                onClick={saveHoliday}
                            >
                                Save
                            </button>
                        </div>
                    </div>

                </>
            )}

            {activeTab === "transit" && (
                <TransitDaysBufferMaster />
            )}
            {activeTab === "zonebuffer" && (
                <ZoneWiseBufferMaster />
            )}
            {activeTab === "seasonalbuffer" && (
                <SeasonalBufferMaster />
            )}
            {activeTab === "delaycategory" && (
                <DelayCategoryMaster />
            )}

            <div className={"dataLoadpage " + (showloader)}>
            </div>
            <div className={"dataLoadpageimg " + (showloader)}>
                <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
            </div>
            <div className={"overlay-part " + (overlay)} ></div>


        </div>
    );
}

export default Masters;
const capitalizeWords = (str) => {
    if (typeof str !== "string") {
        console.warn("Invalid input to capitalizeWords:", str); // Log invalid inputs for debugging
        return ""; // Return an empty string for non-string inputs
    }
    return str
        .toLowerCase()
        .replace(/\b\w/g, char => char?.toUpperCase());
};  